import React, {useState} from "react";
import {editTransaction} from "../store/actions";
import {useDispatch, useSelector} from 'react-redux';
import Button from '@mui/material/Button';
import {Container, Typography} from "@material-ui/core";
import {DataGrid, GridActionsCellItem, GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton} from '@mui/x-data-grid';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';

import {getCurrencySymbol} from "./utils/currency";
import {getTransactionsLabel} from "./utils/transactions";
import {getPortfolio, sendDeals, updateImport, updateUserPortfolio} from "../store/actions";
import Service from "../services/Service";
import fileDownload from 'js-file-download';
import GetAppIcon from '@material-ui/icons/GetApp';
import {formattingMoney} from "./utils/formatting";
import {map_transactions} from "./utils/mapping";
import ImportReport from "./ImportReport";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Hidden from "@mui/material/Hidden";
import Paper from "@mui/material/Paper";

export default function Transactions() {
    const service = new Service();
    const dispatch = useDispatch();
    const portfolioList = useSelector(store => store.portfolios?.list);
    const selectedIndex = useSelector(store => store.user.portfolio);
    const result = useSelector(store => store.portfolio?.data)
    const portfolio = portfolioList[selectedIndex] || undefined

    const isLoadind = useSelector(store => store.import?.isLoad)

    //start for dialog
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const HandleClear=()=> {
        setOpen(false);
        service.ClearPortfolio(result.portfolio.id).then((response) => {
            dispatch(getPortfolio(result.portfolio.id));
        }).catch(() => {
            alert('Ошибка при очистке');
        });
    }
    //end for dialog

    const deleteTrans = (id) => {
        service.deleteTransaction(id).then(function (response) {
                if (portfolio) {
                    dispatch(getPortfolio(portfolio?.id));
                }
            }
        )
        //event.stopPropagation();
    }
    const HandleExport=()=> {
        service.getExcelPortfolio(result.portfolio.id).then((response) => {
            fileDownload(response.data, `portfolio_${result.portfolio.id}.xlsx`);
        })
    }



    const editTrans = (value) => {
        dispatch(editTransaction(value))

    }
    const [sortModel, setSortModel] = useState([
        {
            field: 'dateTime',
            sort: 'desc',
        },
    ]);

    const columns = [
        {
            field: 'ticker',
            headerName: 'Актив',
            description: 'Актив',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <div>
                    {/*<Avatar variant="rounded">*/}
                    {/*    f*/}
                    {/*</Avatar>*/}
                    <div>
                    <Typography variant="body2">{params.value}</Typography>
                    <Typography color="textSecondary" variant="body2">{params.api.getCellValue(params.id, 'name')}</Typography>
                    </div>
                </div>
            )
        },
        {
            field: 'type',
            headerName: 'Операция',
            //width: 150,
            valueFormatter: (params) => {
                return `${getTransactionsLabel(params.value)}`;
            },
        },
        {
            field: 'dateTime',
            type: 'dateTime',
            align: 'right',
            headerName: 'Дата',
            valueFormatter: (params) => {
                return `${(new Date(params.value)).toLocaleDateString('ru-RU',{year: 'numeric', month: 'short', day: 'numeric'})}`;
            },
            width: 125,
            // renderCell: (params) => (
            //     <>
            //         {(new Date(params.value)).toLocaleDateString() }
            //         </>
            // ),
        },
        {
            field: 'quantity',
            headerName: 'Количество',
            type: 'number',
            width: 90,
            valueFormatter: (params) => {
                return `${formattingMoney(Math.abs(Number(params.value)))}`;
            },
        },
        {
            field: 'price',
            headerName: 'Цена',
            align: 'right',
            width: 120,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(params.api.getCellValue(params.id, 'currency'))}`;
            },
        },
        {
            field: 'commission_pc',
            headerName: 'Комиссия',
            description: 'Комиссия',
            type: 'number',
            align: 'right',
            minWidth: 120,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(result.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 'commission')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'commission_currency'))}</Typography>
                </div>
            )
        },
        {
            field: 'accruedint',
            headerName: 'НКД',
            hide: true,
            width: 120,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(params.api.getCellValue(params.id, 'currency'))}`;
            },
        },
        {
            field: 'summa_full_pc',
            headerName: 'Сумма',
            description: 'Сумма',
            type: 'number',
            align: 'right',
            minWidth: 120,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Math.abs(params.value))} {getCurrencySymbol(result.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Math.abs(params.api.getCellValue(params.id, 'summa_full')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'currency'))}</Typography>
                </div>
            )
        },
        {
            field: 'actions',
            type: 'actions',
            //headerName: 'Действия',
            width: 70,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<EditIcon/>}
                    label="Редактировать"
                    onClick={() => {editTrans(params)}}

                />,
                <GridActionsCellItem
                    icon={<DeleteOutlineIcon/>}
                    label="Удалить"
                    onClick={() => {
                        deleteTrans(params.id)
                    }}

                />,
            ],
        },
    ];

    return (
        <Container style={{marginTop: 30, marginBottom: 110}}>
            <ImportReport/>

            <Hidden mdUp>
                <Paper sx={{mb:1, backgroundColor:'#F4F6FA'}}>
                <Button
                    // href={"https://test.investmonitoring.ru/api/portf/"+portfolio.id+"/?f=xlsx"}
                    // onClick={HandleExport(service,portfolio.id)}
                    onClick={() => {
                        HandleExport()
                    }}
                    startIcon={<GetAppIcon />}
                    // target={"_blank"}
                >
                    Экспорт в Excel
                </Button>
                <Button
                    onClick={handleClickOpen}
                    startIcon={<DeleteOutlineIcon/>}
                >
                    Очистить
                </Button>
                </Paper>
            </Hidden>
            <div style={{ width: '100%'}}>
                <DataGrid
                    autoHeight
                    rows={map_transactions(result)}
                    columns={columns}
                    pageSize={25}
                    rowsPerPageOptions={[25, 50, 100]}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                    //checkboxSelection
                    //disableSelectionOnClick
                    disableColumnMenu
                    // componentsProps={{
                    //     pagination: {
                    //         labelRowsPerPage:'Сделок на странице:',
                    //         backIconButtonText:'Назад',
                    //         nextIconButtonText:'Вперед',
                    //         labelDisplayedRows:({ from, to, count }) => `${from}–${to} из ${count !== -1 ? count : `больше чем ${to}`}`
                    // }
                    // }}
                    components={{
                        Toolbar: function CustomToolbar() {
                            return (
                                <GridToolbarContainer>
                                    <GridToolbarColumnsButton />
                                    <GridToolbarFilterButton />
                                    <Hidden smDown>
                                    <Button
                                        // href={"https://test.investmonitoring.ru/api/portf/"+portfolio.id+"/?f=xlsx"}
                                        // onClick={HandleExport(service,portfolio.id)}
                                        onClick={() => {
                                            HandleExport()
                                        }}
                                        startIcon={<GetAppIcon />}
                                        // target={"_blank"}
                                    >
                                        Экспорт в Excel
                                    </Button>
                                    <Button
                                        onClick={handleClickOpen}
                                        startIcon={<DeleteOutlineIcon/>}
                                    >
                                        Очистить
                                    </Button>
                                    </Hidden>
                                </GridToolbarContainer>
                            );
                        },
                    }}
                />
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Очистка потфеля
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Все сделки данного портфеля будут удалены
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Отмена</Button>
                        <Button onClick={HandleClear} autoFocus>
                            Подтвердить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </Container>
    );
}

